import z from 'zod'

export const InsuranceCompanySchema = z.object({
  id: z.number(),
  name: z.string(),
  url: z.string().url().optional().nullable(),
  uniqueId: z.string().optional().nullable(),
  logo: z.string().url().optional().nullable(),
  defaultOn: z.boolean(),
  bannerText: z.string().optional().nullable(),
})

export const InsuranceCompanyListSchema = z.array(InsuranceCompanySchema)
